import type { CarouselTab, CarouselTabConfig } from './LandingCarousel.types';

import instructIcon from '../../assets/instruct-icon.svg';
import manageIcon from '../../assets/manage-icon.svg';
import trainIcon from '../../assets/train-icon.svg';

export const CAROUSEL_TABS: CarouselTabConfig[] = [
  {
    id: 'manage',
    labelKey: 'landingPage.carousel.manage.label',
    sublabelKey: 'landingPage.carousel.manage.sublabel',
    iconSrc: manageIcon,
  },
  {
    id: 'train',
    labelKey: 'landingPage.carousel.train.label',
    sublabelKey: 'landingPage.carousel.train.sublabel',
    iconSrc: trainIcon,
  },
  {
    id: 'instruct',
    labelKey: 'landingPage.carousel.instruct.label',
    sublabelKey: 'landingPage.carousel.instruct.sublabel',
    iconSrc: instructIcon,
  },
];

export const AUTO_SWITCH_INTERVAL_MS = 6000;

export function getNextTab(currentTab: CarouselTab): CarouselTab {
  const tabs = CAROUSEL_TABS.map(t => t.id);
  const currentIndex = tabs.indexOf(currentTab);
  return tabs[(currentIndex + 1) % tabs.length];
}

export function getAdjacentTab(
  current: CarouselTab,
  direction: 'next' | 'prev'
): CarouselTab | null {
  const index = CAROUSEL_TABS.findIndex(tab => tab.id === current);
  if (direction === 'next') {
    return index < CAROUSEL_TABS.length - 1 ? CAROUSEL_TABS[index + 1].id : null;
  }
  return index > 0 ? CAROUSEL_TABS[index - 1].id : null;
}
